// Pagination page size might need to be dynamic on responsive page layouts
// Current design has max 3 columns 12 is divisible by 2 and 3
// So, there's enough cards to fill all columns on full pagination pages
export const SEARCH_WITH_MAP_DEBOUNCE = 500; // Little bit of debounce before search is initiated.
